import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { css } from '@emotion/react';
import { CircularProgress, Grid } from '@material-ui/core';
import * as ROUTES from '../../../constants/routes';
import { fetchSso, startSsoLogin } from '@/utilities/ssoClient';
import { colors } from '@/styles';

// The deep link carries no email, so :type names the tenant. The exchange re-resolves it from the
// verified token, so it is a hint, not a grant.
function SsoRedirect() {
    const { type } = useParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchSso(type)
            .then(startSsoLogin)
            .catch((err) => {
                console.error('SSO redirect error:', err);
                setError(err.message || 'SSO is not available for this link.');
            });
    }, [type]);

    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            css={css`
                margin-top: 128px;
            `}
        >
            {error ? (
                <>
                    <p
                        css={css`
                            color: ${colors.reds.primary};
                        `}
                    >
                        {error}
                    </p>
                    <Link to={ROUTES.SIGNIN}>
                        <b>Back to Sign In</b>
                    </Link>
                </>
            ) : (
                <>
                    <CircularProgress />
                    <p style={{ marginTop: '1rem' }}>Redirecting to your identity provider...</p>
                </>
            )}
        </Grid>
    );
}

export default SsoRedirect;
